import { Param } from '../Param';

export class Facet {
	constructor({ id, label, parentId = null, count = 0, selected = false }) {
		this.type = "Facet";
		this.id = id;
		this.parentId = parentId;
		this.label = label;
		this.selected = selected;
		this.count = count;
	}

	static buildFromJson(rawFacet, parentId = null) {
		return new Facet({
			id: rawFacet.id,
			parentId: parentId,
			label: rawFacet.name,
			selected: rawFacet.selected,
			count: rawFacet.count
		});

	}
}